import { DefaultAPIInstance } from "@/api";

const get_personal_data_url = 'admin/users/';
const update_personal_data_url = 'admin/users/update/';

export const AdminAPI = {
    getPersonalData(userData) {
        return DefaultAPIInstance.get(get_personal_data_url, {params: userData})
    },
    updatePersonalData(userData) {
        return DefaultAPIInstance.patch(`${update_personal_data_url}${userData.id}/`, userData)
    }
}
